// src/services/home.service.js
import axios from "axios";
import { BaseUrl } from "../App";
import BuyerServicesUrl from "../BuyerServicesUrl";
// import { mapProduct } from "../models/product.model";
import { mapProduct } from "../models/Product/ProductResponseModel";
export const fetchHomeData = async (token) => {
  const res = await axios.get(
    `${BaseUrl}${BuyerServicesUrl.Home}`,
    {
      // headers: {
      //   Authorization: `Bearer ${token}`,
      //   Accept: "application/json",
      // },
       headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        Accept: "application/json",
      },
    }
  );

  return res.data.data;
};

